<section id="reviews"
    class="padding-110px-tb bg-gray padding-110px-tb testimonial-style7 border-none xs-padding-60px-tb">
    <div class="container">
        <div class="row">
            <!-- section title -->
            <div class="col-md-12 col-sm-12 col-12 text-center">
                <h2
                    class="section-title-large sm-section-title-medium xs-section-title-large text-servios font-weight-700 alt-font margin-three-bottom xs-margin-fifteen-bottom">
                    Lo que dicen nuestros clientes</h2>
                <div
                    class="text-medium width-60 margin-lr-auto md-width-70 sm-width-100 margin-thirteen-bottom xs-margin-nineteen-bottom">
                    Gracias a quienes están confiando en nosotros. ¡Servios te cuida, les cuida, nos cuida!
                </div>
            </div>
            <!-- end section title -->
        </div>
        <div class="row">
            <!-- testimonial item -->
            <div class="col-md-4 col-sm-4 col-12 xs-text-center xs-margin-nine-bottom  wow fadeIn">
                <div class="testimonial-box bg-white pull-left width-100 text-center" style="min-height: 406px;">
                    <div class="icon-medium text-yellow margin-thirteen-bottom margin-six-top">
                        <i class="fa fa-quote-left" aria-hidden="true"></i></div>
                    <div class="text-medium">
                        <p>Servios es una empresa con un buen trato hacia el cliente y que se ve involucrada en los
                            proyectos a llevar a cabo del cliente, actúa con rapidez y solidez se adapta a las
                            normativas e ideas del cliente, respetando la idea del mismo.</p>
                    </div>
                    <div class="text-large text-yellow margin-six-top">
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <i class="fa fa-star" aria-hidden="true"></i>
                    </div>
                    <span
                        class="alt-font text-dark-gray margin-two-top sm-text-medium display-block font-weight-600">Alvaro
                        Espinola </span>
                    <span class="alt-font text-extra-small sm-text-medium display-block">Gerente Comercial
                        Carsuplay</span>
                </div>
            </div>
            <!-- end testimonial item -->
            <!-- testimonial item -->
            <div class="col-md-4 col-sm-4 col-12 xs-text-center xs-margin-nine-bottom  wow fadeIn">
                <div class="testimonial-box bg-white pull-left width-100 text-center builder-bg"
                    style="min-height: 406px;">
                    <div class="icon-medium text-yellow margin-thirteen-bottom margin-six-top">
                        <i class="fa fa-quote-left" aria-hidden="true"></i>
                    </div>
                    <div class="text-medium">
                        <p>Se destaca por la calidad en sus productos y una pronta respuesta buscando soluciones para la
                            empresa, llegando a los tiempos necesarios y ayudando en la planificación de un proyecto.
                        </p>
                    </div>
                    <div class="text-large text-yellow margin-six-top">
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <i class="fa fa-star" aria-hidden="true"></i>
                    </div>
                    <span
                        class="alt-font text-dark-gray margin-two-top sm-text-medium display-block font-weight-600">Hugo
                        Rojas</span>
                    <span class="alt-font text-extra-small sm-text-medium display-block">Stanley</span>
                </div>
            </div>
            <!-- end testimonial item -->
            <!-- testimonial item -->
            <div class="col-md-4 col-sm-4 col-12 xs-text-center  wow fadeIn">
                <div class="testimonial-box bg-white pull-left width-100 text-center" style="min-height: 406px;">
                    <div class="icon-medium text-yellow margin-thirteen-bottom margin-six-top">
                        <i class="fa fa-quote-left" aria-hidden="true"></i>
                    </div>
                    <div class="text-medium">
                        <p>Cuentan con profesionales que saben captar perfectamente nuestra idea. Intuitivos, porque
                            supieron ampliar nuestra idea y trasladar a sus trabajos. Nosotros estamos contentos con
                            Servios porque les consideramos
                            unos buenos profesionales.</p>
                    </div>
                    <div class="text-large text-yellow margin-six-top">
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <i class="fa fa-star" aria-hidden="true"></i>
                    </div>
                    <span
                        class="alt-font text-dark-gray margin-two-top sm-text-medium display-block font-weight-600">Jessica
                        Piris</span>
                    <span class="alt-font text-extra-small sm-text-medium display-block">Bakertilly</span>
                </div>
            </div>
            <!-- end testimonial item -->
        </div>
    </div>
</section>